import { ref } from 'vue'
// @ts-ignore
import { UAParser } from 'ua-parser-js'

export default function useHeic() {
  const prevUserAgent = ref('')
  const isSafariBrowser = ref(false)

  function checkIsSafari() {
    if (prevUserAgent.value === window.navigator.userAgent) {
      return isSafariBrowser.value
    }

    try {
      const browserParser = new UAParser(window.navigator.userAgent)
      const { name } = browserParser.getEngine()

      prevUserAgent.value = window.navigator.userAgent
      isSafariBrowser.value = !!name?.toLowerCase().includes('webkit')
    } catch {
      isSafariBrowser.value = false
    }

    return isSafariBrowser.value
  }

  function checkHeicNoSafari(file: File) {
    return file.name.split('.').pop()?.toLowerCase() === 'heic' && !checkIsSafari()
  }

  return {
    checkHeicNoSafari,
  }
}
